import { NL_REPORT } from './../../hooks/apiEndPoints';
export enum PermissionEnum {
  Dashboard_Permission = 0,
  Role_Permission = 1,
  Staff_Permission = 2,
  Material_Permission = 3,
  Color_Permission = 4,
  Carrier_Permission = 5,
  Ply_Permission = 6,
  Production_Process_Permission = 7,
  Production_Station_Permission = 8,
  Production_Screen_Permission = 9,
  Part_Permission = 10,
  Part_Assembly_Permission = 11,
  Customer_Permission = 12,
  Order_Permission = 13,
  Packaging_Permission = 14,
  Shipping_Permission = 15,
  Production_Schedule_Permission = 16,
  Attachment_Screen_Permission = 17,
  Engineering_Permission = 18,
  Attachment_Permission = 19,
  Holiday_Permission = 20,
  Export_Permission = 21,
  PO_Link_Permission = 22,
  Cancel_Order_Permission = 23,
  New_Part_Permission = 24,
  Shipped_Order_Permission = 25,
  Open_Order_Permission = 26,
  Managers_Activity_Report_Permission = 27,
  Fabrication_Report_Permission = 28,
  Estimation_Permission = 29,
  Label_Permission = 30,
  Bun_Qty_Permission = 31,
  Cost_Method_Permission = 32,
  Component_Master_Permission = 33,
  Part_Component_Permission = 34,
  Manufacturer_Permission = 35,
  User_Activity_Report_Permission = 36,
  Makeup_Report_Permission = 37,
  Weight_Entry_Permission = 38,
  Daily_Parts_Widget_Permission = 39,
  Scheduled_Parts_Widget_Permission = 40,
  Tracking_Reports_Permission = 41,
  WEB_ORDER_PERMISSION = 42,
  SHOP_ITEM_PERMISSION = 43,
  CATEGORY_PERMISSION = 44,
  CAROUSEL_IMAGE_PERMISSION = 45,
  WEB_VIEW_PERMISSION = 46,
  CUSTOMER_ORDER_REPORT_PERMISSION = 47,
  MSRP_FIELD_PERMISSION = 48,
  VALUE_FIELD_PERMISSION = 49,
  WAREHOUSE_FIELD_PERMISSION = 50,
  UTILIZATION_REPORT_FIELD_PERMISSION = 51,
  PRODUCTION_OPEN_ORDER_REPORT_PERMISSION = 52,
  HI_LO_PERMISSION = 53,
  WORKING_DAY_PERMISSION = 54,
  INVENTORY_SCREEN_PERMISSION = 55,
  INVENTORY_REPORT_PERMISSION = 56,
  RMA_PERMISSION = 57,
  RAW_PARTS_PERMISSION = 58,
  SKIVING_PERMISSION = 59,
  TIME_CLOCK_REPORT_PERMISSION = 60,
  MAP_VIEW_PERMISSION = 61,
  WIDTH_PERMISSION = 62,
  VACATION_APPROVAL_PERMISSION = 63,
  TEAM_LEAD_PERMISSION = 64,
  NOTICE_PERMISSION = 65,
  WORKFLOW_PERMISSION = 66,
  PART_REQUEST_PERMISSION = 67,
  PART_THOMPSON_DIE_BOARD_PERMISSION = 68,
  OLD_PART_CREATE_PERMISSION = 69,
  CUT_PERMISSTION = 70,
  HEADER_PERMISSION = 71,
  SIZE_PERMISSION = 72,
  CATEGORY_HELP_TEXT_PERMISSION = 73,
  EVENT_PERMISSION = 74,
  LEAD_SCREEN_PERMISSION = 75,
  QTY_YIELD_PERMISSION = 76,
  LENGTH_SETTING_PERMISSION = 77,
  WIDTH_SETTING_PERMISSION = 78,
  TESTIMONIAL_PERMISSION = 79,
  DIE_BOARD_PERMISSION = 80,
  HOW_TO_VIDEO_PERMISSION = 81,
  PARTS_OPEN_ORDERS_PERMISSION = 82,
  HARDWARE_PERMISSION = 83,
  DUPLICATE_ASSEMBLIES_PERMISSION = 84,
  NL_REPORT_PERMISSION = 86,
  STAFF_POINT_INFRACTION = 87,
  DELETE_PRODUCTION_STEPS_PERMISSION = 90,
  LEAD_SOURCE_PERMISSION = 91,
  OPPORTUNITY_PERMISSION = 92,
  ACTIVITY_PERMISSION = 93,
  WEB_USER_PERMISSION = 94,
  SITES_PERMISSION = 95,
  CALL_RAIL_PERMISSION = 96,
}
